import React, { useEffect, useState } from "react";
import { use } from "react";
import { toast } from "react-toastify";
import { Dropdown, Form, Grid, Label, Segment, Dimmer, Loader, Button, Input, Divider, Icon, Modal, Header, List, Checkbox, Radio } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as DEEPANALYSIS_ACTIONS from "../../../actions/deepanalysisActions";
import * as LOOKUPS_ACTIONS from '../../../actions/lookupsActions';
import * as USER_GROUPS from '../../../actions/userGroupsActions';
import * as KML_ACTIONS from '../../../actions/kmlUploadActions';
import * as TENANT_CLOUD_ACTIONS from "../../../actions/tenantCloudActions";

import _ from "lodash";
import { connect } from "react-redux";
import { Storage } from 'aws-amplify';
import GraphHtmlRenderer from "./GraphHtmlRenderer";
import FuseContentModal from '../../../components/generic/FuseContentModal';
import GraphModal from "./graphModal";
import { useHistory } from "react-router-dom";

// Custom styles for the DatePicker component
const datePickerStyles = document.createElement('style');
datePickerStyles.innerHTML = `
    .react-datepicker-popper {
        z-index: 9999 !important;
    }
    
    .view-analysis-btn {
        transition: all 0.2s ease-in-out !important;
    }
    
    .view-analysis-btn:hover {
        transform: translateY(-1px) !important;
        box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3) !important;
    }
`;
document.head.appendChild(datePickerStyles);

const CustomDatePickerInput = React.forwardRef(({ value, onClick }, ref) => (
    <Input
        icon="calendar"
        iconPosition="left"
        placeholder="Select Date"
        onClick={onClick}
        value={value}
        ref={ref}
        style={{ borderRadius: '8px', borderColor: '#ccc' }}
    />
));


const CustomAnalysisQueryPage = (props) => {
    const { tenant, questionnaires = [] } = props;
    const history = useHistory();

    // Helper function to get cloud tenants for a specific questionnaire
    const getCloudTenantsForQuestionnaire = (questionnaireId) => {
        const tenantClouds = props.tenantClouds.filter(cloud =>
            cloud.tenants && cloud.tenants.some(tenant => tenant.id === props.tenant.id) &&
            cloud.questionnaires && cloud.questionnaires.some(questionnaire => questionnaire.id === questionnaireId)
        );

        const cloudTenants = [];
        tenantClouds.forEach(cloud => {
            if (cloud.tenants) {
                cloud.tenants.forEach(tenant => {
                    cloudTenants.push(tenant);
                    // if (tenant.id !== props.tenant.id && !cloudTenants.some(ct => ct.id === tenant.id)) {
                    // }
                });
            }
        });

        return cloudTenants;
    };
    const [state, setState] = useState({
        loading: false,
        isViewFileOpen: false,
        navigating: false,
    });
    const [selectedQnaire, setSelectedQnaire] = useState(null);
    const [lookupGraphType, setLookupGraphType] = useState(null);
    const [textGraphType, setTextGraphType] = useState(null);
    const [filterQuestion, setFilterQuestion] = useState([]);
    const [filterQuestions, setFilterQuestions] = useState([]);
    const [userGroup, setUserGroup] = useState(null);
    const [kmlFile, setKMLFile] = useState(null);
    const [kmlDistanceOption, setKMLDistanceOption] = useState(null);
    const [kmlDistanceOptionValue, setKMLDistanceOptionValue] = useState(1);
    const [filterValue, setFilterValue] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [analyzeLoading, setAnalyzeLoading] = useState(false);
    const [showQuestionsModal, setShowQuestionsModal] = useState(false);
    const [showQuestionValueModal, setShowQuestionValueModal] = useState(false);
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [selectedQuestionValue, setSelectedQuestionValue] = useState(null);
    const [analysisQuestions, setAnalysisQuestions] = useState([]);
    const [showFilterQuestionnaireModal, setShowFilterQuestionnaireModal] = useState(false);
    const [showFilterQuestionsModal, setShowFilterQuestionsModal] = useState(false);
    const [selectedFilterQuestionnaire, setSelectedFilterQuestionnaire] = useState(null);
    const [filterQuestionsList, setFilterQuestionsList] = useState([]);
    const [showAnalysisQuestionnaireModal, setShowAnalysisQuestionnaireModal] = useState(false);
    const [selectedAnalysisQuestionnaire, setSelectedAnalysisQuestionnaire] = useState(null);
    const [uniquePerUser, setUniquePerUser] = useState(false);

    // Check if there's a location question in the filter questions
    const hasLocationQuestionInFilters = filterQuestions.some(fq => {
        const question = props.graphQuestions.find(q => q.id === fq.id);
        return question && question.questionType === 'location';
    });

    // Get the location question from filter questions (should only be one)
    const locationQuestionInFilters = filterQuestions.find(fq => {
        const question = props.graphQuestions.find(q => q.id === fq.id);
        return question && question.questionType === 'location';
    });

    const hasPermissions = (category) => {
        return (
            !_.isEmpty(props.userPermissions) &&
            props.userPermissions.hasOwnProperty(category)
        );
    };

    const isAdmin = () => {
        return (
            hasPermissions("Other") && props.userPermissions["Other"].actions.admin
        );
    };

    const canReadQuestionnaireAnalysis = () => {
        return (hasPermissions('Deep Analysis') && props.userPermissions['Deep Analysis'].actions["VIEW QUESTIONNAIRE ANALYSIS"])
            || isAdmin();
    }

    const canCreateQuestionnaireAnalysis = () => {
        return hasPermissions('Deep Analysis') && canReadQuestionnaireAnalysis() && props.userPermissions['Deep Analysis'].actions["CREATE QUESTIONNAIRE ANALYSIS"]
            || isAdmin();
    }

    const questionnaireOptions = questionnaires
        .map(q => ({
            key: q.id,
            value: q,
            text: q.name || q.title || `Questionnaire ${q.id}`,
        }))
        .sort((a, b) => a.text.localeCompare(b.text));

    const lookupGraphTypeOptions = [
        { key: 'bar', value: 'bar', text: 'Bar Chart' },
        // { key: 'pie', value: 'pie', text: 'Pie Chart' },
        // { key: 'line', value: 'line', text: 'Line Chart' },
    ].sort((a, b) => a.text.localeCompare(b.text));

    const textGraphTypeOptions = [
        { key: 'bar', value: 'bar', text: 'Bar Chart' },
        { key: 'wordCloud', value: 'wordCloud', text: 'Word Cloud' },
    ].sort((a, b) => a.text.localeCompare(b.text));

    const userGroupOptions = [
        { key: 'none', value: null, text: 'None' },
        ...props.userGroups
            .map(g => ({
                key: g.id,
                value: g,
                text: g.name || `Group ${g.id}`,
            }))
            .sort((a, b) => a.text.localeCompare(b.text))
    ];

    const kmlFileOptions = [
        { key: 'none', value: null, text: 'None' },
        ...props.kmlFiles
            .map(f => ({
                key: f.id,
                value: f,
                text: f.name || `File ${f.id}`,
            }))
            .sort((a, b) => a.text.localeCompare(b.text))
    ];

    const polygonRuleDistanceOptions =
        [
            { key: 'none', value: null, text: 'None' },
            // { key: 'along_boundary', value: 'along_boundary', text: 'Along the boundary of the polygon' },
            { key: 'any_pin', value: 'any_pin', text: 'Any PIN (such as a school)' },
            { key: 'on_boundary', value: 'on_boundary', text: 'On or within the boundary of this polygon' },
            // { key: 'within_x_meters', value: 'within_x_meters', text: 'Within x meters of any point' },
            // { key: 'within_x_meters_polygon_boundary', value: 'within_x_meters_polygon_boundary', text: 'Within x meters of the boundary of the polygon' },
        ];

    useEffect(() => {
        if (!_.isEmpty(props.tenant)) {
            if (props.isPermissionsFetched) {
                if (canReadQuestionnaireAnalysis()) {
                    props.fetchCustomQuueriesAction(props.tenant);
                    props.fetchUserGroupsAction(props.tenant);
                    props.fetchKmlFilesAction(props.tenant);
                    props.fetchTenantCloudsAction();
                } else {
                    toast.error('You do not have permission to view this page.');
                }
            }
        }
    }, [props.tenant]);

    const refreshQnaireData = () => {
        props.fetchCustomQuueriesAction(props.tenant);
    };

    const analyse = async () => {
        setAnalyzeLoading(true);
        const payload = {
            lookupGraphType,
            textGraphType,
            tenantId: tenant.id,
            tenantName: tenant.name,
            startDate: startDate ? startDate.toISOString() : null,
            endDate: endDate ? endDate.toISOString() : null,
            userGroup: userGroup ? userGroup : null,
            analysisQuestions: analysisQuestions,
            uniquePerUser: uniquePerUser
        };
        if (kmlFile) {
            payload.kmlFileId = kmlFile.id;
            payload.kmlName = kmlFile.name;
            payload.kmlMarkers = kmlFile.kmlMarkers || [];
            payload.kmlPolygons = kmlFile.kmlPolygons || [];
            payload.kmlPolylines = kmlFile.kmlPolylines || [];
            payload.kmlDistanceOption = kmlDistanceOption || null;
            payload.kmlDistanceOptionValue = kmlDistanceOptionValue ? parseFloat(kmlDistanceOptionValue) : 1;

            // Add the location question ID if there's a location question in filters
            if (locationQuestionInFilters) {
                payload.kmlLocationQuestionId = locationQuestionInFilters.id;
            }
        }
        if (filterQuestions && filterQuestions.length > 0) {
            payload.filterQuestions = filterQuestions;
        }
        try {
            let isInitiated = await props.analyseCustomQueryAction(payload);
            if (isInitiated) {
                toast.success("Analysis Successfully Initiated");
                toast.info("Please wait 30 minutes for the analysis to complete.")
            } else {
                toast.error("Failed to initiate analysis. Please try again");
            }
        } catch (error) {
            toast.error("Failed to initiate analysis. Please try again");
        } finally {
            setAnalyzeLoading(false);
        }
    };

    const handleDateChange = (type, date) => {
        if (type === 'startDate') setStartDate(date);
        if (type === 'endDate') setEndDate(date);
    };

    const getQuestionTextById = (id) => {
        if (!props.graphQuestions || !Array.isArray(props.graphQuestions)) return '';
        const q = props.graphQuestions.find(q => q.id === id);
        return q ? q.question : '';
    };

    return (
        <Form>
            <Segment>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={14}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <h3>Custom Analysis</h3>
                            </div>
                        </Grid.Column>
                        <Grid.Column floated="right" width={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <Form.Button compact primary icon='refresh' size='small' floated='right'
                                onClick={(e) => {
                                    e.preventDefault();
                                    refreshQnaireData();
                                }}></Form.Button>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={6}>
                            <Label style={{ marginBottom: '8px' }}>Analysis Questions:</Label>
                            <Button
                                fluid
                                primary
                                icon="plus"
                                content="Add Analysis Question"
                                onClick={() => setShowAnalysisQuestionnaireModal(true)}
                            />
                        </Grid.Column>
                        {/* Conditionally show graph type dropdowns based on main question type */}
                        {(() => {
                            const mainQuestionType = analysisQuestions.length > 0 ? analysisQuestions[0].questionType : null;
                            const showLookupGraphType = mainQuestionType && ['yes_no', 'multi_select', 'mc_sel_one'].includes(mainQuestionType);
                            const showTextGraphType = mainQuestionType && ['val_string', 'val_paragraph'].includes(mainQuestionType);

                            if (showLookupGraphType) {
                                return (
                                    <Grid.Column width={6}>
                                        <Label style={{ marginBottom: '8px' }}>Graph Type for Lookup Questions:</Label>
                                        <Dropdown
                                            placeholder="Select Graph Type"
                                            fluid
                                            selection
                                            options={lookupGraphTypeOptions}
                                            value={lookupGraphType}
                                            onChange={(e, { value }) => setLookupGraphType(value)}
                                        />
                                    </Grid.Column>
                                );
                            }



                            if (showTextGraphType) {
                                return (
                                    <Grid.Column width={6}>
                                        <Label style={{ marginBottom: '8px' }}>Graph Type for Text-based Questions:</Label>
                                        <Dropdown
                                            placeholder="Select Graph Type"
                                            fluid
                                            selection
                                            options={textGraphTypeOptions}
                                            value={textGraphType}
                                            onChange={(e, { value }) => setTextGraphType(value)}
                                        />
                                    </Grid.Column>
                                );
                            }

                            return null;
                        })()}
                        <Grid.Column width={4}>
                            <Checkbox
                                toggle
                                label="Unique per user"
                                checked={uniquePerUser}
                                onChange={(e, { checked }) => setUniquePerUser(checked)}
                                style={{ paddingTop: '45px' }}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    {analysisQuestions && analysisQuestions.length > 0 && (
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <div style={{ padding: '12px', border: '1px solid #ddd', borderRadius: '4px' }}>
                                    <Label style={{ marginBottom: '8px' }}>Selected Analysis Questions:</Label>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                                        <thead>
                                            <tr style={{ borderBottom: '1px solid #ddd' }}>
                                                <th style={{ padding: '8px', textAlign: 'left' }}>Questionnaire</th>
                                                <th style={{ padding: '8px', textAlign: 'left' }}>Question</th>
                                                <th style={{ padding: '8px', textAlign: 'left' }}>Value(s)</th>
                                                <th style={{ padding: '8px', textAlign: 'center', width: '120px' }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {analysisQuestions.map((aq, index) => {
                                                // Use stored question data instead of looking it up from current questionnaire
                                                return (
                                                    <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                                                        <td style={{ padding: '8px' }}>
                                                            <div style={{ backgroundColor: '#28a745', color: 'white', padding: '2px 6px', borderRadius: '10px', fontSize: '12px', display: 'inline-block' }}>
                                                                {aq.questionnaireName || 'Unknown Questionnaire'}
                                                            </div>
                                                        </td>
                                                        <td style={{ padding: '8px' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                <div style={{
                                                                    backgroundColor: index === 0 ? '#e74c3c' : '#3498db',
                                                                    color: 'white',
                                                                    padding: '2px 6px',
                                                                    borderRadius: '10px',
                                                                    fontSize: '12px'
                                                                }}>
                                                                    {index === 0 ? 'Main' : 'Secondary'}
                                                                </div>
                                                                <span>{aq.question || `Question ${aq.id}`}</span>
                                                            </div>
                                                        </td>
                                                        <td style={{ padding: '8px' }}>
                                                            {aq.value === null ? (
                                                                <div style={{ backgroundColor: '#6c757d', color: 'white', padding: '2px 6px', borderRadius: '10px', fontSize: '12px', display: 'inline-block' }}>
                                                                    No value required
                                                                </div>
                                                            ) : Array.isArray(aq.value) ? (
                                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                                    {aq.value.map((val, i) => (
                                                                        <div key={i} style={{ backgroundColor: '#3A95A4', color: 'white', padding: '2px 6px', borderRadius: '10px', fontSize: '12px' }}>
                                                                            {val}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <div style={{ backgroundColor: '#3A95A4', color: 'white', padding: '2px 6px', borderRadius: '10px', fontSize: '12px', display: 'inline-block' }}>
                                                                    {aq.value}
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td style={{ padding: '8px', textAlign: 'center' }}>
                                                            <Button.Group size="mini">
                                                                {/* Only show edit button for question types that require values */}
                                                                {['val_paragraph', 'val_string'].includes(aq.questionType) && (
                                                                    <Button
                                                                        icon="edit"
                                                                        color="blue"
                                                                        onClick={() => {
                                                                            // Create a question object from stored data
                                                                            const questionObj = {
                                                                                id: aq.id,
                                                                                question: aq.question,
                                                                                questionType: aq.questionType
                                                                            };
                                                                            setSelectedQuestion(questionObj);
                                                                            setSelectedQuestionValue(aq.value);

                                                                            // Set the questionnaire context for editing
                                                                            setSelectedAnalysisQuestionnaire(aq.questionnaire);
                                                                            setSelectedQnaire(aq.questionnaire);

                                                                            // Fetch lookup and show modal for value selection
                                                                            props.fetchQuestionLookup(questionObj);
                                                                            setShowQuestionValueModal(true);
                                                                        }}
                                                                    />
                                                                )}
                                                                <Button
                                                                    icon="trash"
                                                                    color="red"
                                                                    onClick={() => {
                                                                        const updatedAnalysisQuestions = analysisQuestions.filter((_, i) => i !== index);
                                                                        setAnalysisQuestions(updatedAnalysisQuestions);
                                                                    }}
                                                                />
                                                            </Button.Group>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    <div style={{ marginTop: '10px', textAlign: 'right' }}>
                                        {(() => {
                                            const mainQuestionType = analysisQuestions.length > 0 ? analysisQuestions[0].questionType : null;
                                            const isTextQuestion = mainQuestionType && ['val_string', 'val_paragraph'].includes(mainQuestionType);

                                            return (
                                                <Button
                                                    size="small"
                                                    primary={!isTextQuestion}
                                                    disabled={isTextQuestion}
                                                    icon="plus"
                                                    content={isTextQuestion ? "Only one text question allowed" : "Add More Questions"}
                                                    onClick={() => !isTextQuestion && setShowAnalysisQuestionnaireModal(true)}
                                                    title={isTextQuestion ? "Text questions (val_string/val_paragraph) can only be analyzed individually" : "Add more questions for analysis"}
                                                />
                                            );
                                        })()}
                                    </div>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    )}
                    <Divider />
                    <Grid.Row>
                        <Grid.Column width={6}>
                            <Label style={{ marginBottom: '8px' }}>Filter Question:</Label>
                            <Button
                                fluid
                                primary
                                icon="plus"
                                content="Add Filter Question"
                                onClick={() => setShowFilterQuestionnaireModal(true)}
                            />
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <Label style={{ marginBottom: '8px' }}>User Group:</Label>
                            <Dropdown
                                placeholder="Select Group"
                                fluid
                                selection
                                search
                                options={userGroupOptions}
                                value={userGroup}
                                onChange={(e, { value }) => {
                                    setUserGroup(value);
                                }}
                            />
                        </Grid.Column>
                        <Grid.Column width={3}>
                            <Grid.Column>
                                <Label style={{ marginBottom: '8px' }}>Start Date:</Label>
                            </Grid.Column>
                            <Grid.Column >
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => handleDateChange('startDate', date)}
                                    endDate={endDate}
                                    maxDate={endDate}
                                    dateFormat="dd-MM-yyyy"
                                    isClearable
                                    customInput={<CustomDatePickerInput />}
                                    popperClassName="datepicker-popper"
                                    popperPlacement="bottom-start"
                                    popperModifiers={{
                                        preventOverflow: {
                                            enabled: true,
                                            escapeWithReference: false,
                                            boundariesElement: 'viewport'
                                        }
                                    }}
                                />
                            </Grid.Column>
                        </Grid.Column>
                        <Grid.Column width={3}>
                            <Grid.Column >
                                <Label style={{ marginBottom: '8px' }}>End Date:</Label>
                            </Grid.Column>
                            <Grid.Column>
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => handleDateChange('endDate', date)}
                                    startDate={startDate}
                                    minDate={startDate}
                                    dateFormat="dd-MM-yyyy"
                                    isClearable
                                    customInput={<CustomDatePickerInput />}
                                    popperClassName="datepicker-popper"
                                    popperPlacement="bottom-start"
                                    popperModifiers={{
                                        preventOverflow: {
                                            enabled: true,
                                            escapeWithReference: false,
                                            boundariesElement: 'viewport'
                                        }
                                    }}
                                />
                            </Grid.Column>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>

                    </Grid.Row>
                    {filterQuestions && filterQuestions.length > 0 && (
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <div style={{ padding: '12px', border: '1px solid #ddd', borderRadius: '4px' }}>
                                    <Label style={{ marginBottom: '8px' }}>Selected Filter(s):</Label>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                                        <thead>
                                            <tr style={{ borderBottom: '1px solid #ddd' }}>
                                                <th style={{ padding: '8px', textAlign: 'left' }}>Questionnaire</th>
                                                <th style={{ padding: '8px', textAlign: 'left' }}>Question</th>
                                                <th style={{ padding: '8px', textAlign: 'left' }}>Question Type</th>
                                                <th style={{ padding: '8px', textAlign: 'left' }}>Value(s)</th>
                                                <th style={{ padding: '8px', textAlign: 'center', width: '120px' }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filterQuestions.map((fq, index) => {
                                                const question = props.graphQuestions.find(q => q.id === fq.id);
                                                const isLocationQuestion = question && question.questionType === 'location';

                                                return (
                                                    <tr key={index} style={{
                                                        borderBottom: '1px solid #eee',
                                                    }}>
                                                        <td style={{ padding: '8px' }}>
                                                            <div style={{ backgroundColor: '#17a2b8', color: 'white', padding: '2px 6px', borderRadius: '10px', fontSize: '12px', display: 'inline-block' }}>
                                                                {fq.questionnaireName || 'Unknown Questionnaire'}
                                                            </div>
                                                        </td>
                                                        <td style={{ padding: '8px' }}>
                                                            {fq.question || `Question ${fq.id}`}
                                                        </td>

                                                        <td style={{ padding: '8px' }}>
                                                            {fq.questionType || 'Unknown Type'}
                                                        </td>
                                                        <td style={{ padding: '8px' }}>
                                                            {Array.isArray(fq.value) ? (
                                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                                    {fq.value.map((val, i) => (
                                                                        <div key={i} style={{ backgroundColor: '#3A95A4', color: 'white', padding: '2px 6px', borderRadius: '10px', fontSize: '12px' }}>
                                                                            {val}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ) : fq.value ? (
                                                                <div style={{ backgroundColor: '#3A95A4', color: 'white', padding: '2px 6px', borderRadius: '10px', fontSize: '12px', display: 'inline-block' }}>
                                                                    {fq.value}
                                                                </div>
                                                            ) : (
                                                                <div style={{ color: '#6c757d', fontStyle: 'italic' }}>
                                                                    No filter value
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td style={{ padding: '8px', textAlign: 'center' }}>
                                                            <Button.Group size="mini">
                                                                {!isLocationQuestion && (
                                                                    <Button
                                                                        icon="edit"
                                                                        color="blue"
                                                                        onClick={() => {
                                                                            setSelectedFilterQuestionnaire(fq.questionnaire);
                                                                            setFilterQuestion({
                                                                                id: fq.id,
                                                                                question: fq.question,
                                                                                questionType: fq.questionType
                                                                            });
                                                                            setFilterValue(fq.value);
                                                                            props.fetchQuestionLookup({
                                                                                id: fq.id,
                                                                                question: fq.question,
                                                                                questionType: fq.questionType
                                                                            });
                                                                            setShowFilterModal(true);
                                                                        }}
                                                                    />
                                                                )}
                                                                <Button
                                                                    icon="trash"
                                                                    color="red"
                                                                    onClick={() => {
                                                                        const removedQuestion = filterQuestions[index];
                                                                        const updatedFilters = filterQuestions.filter((_, i) => i !== index);

                                                                        // Check if the removed question was a location question
                                                                        const removedQuestionDetails = props.graphQuestions.find(q => q.id === removedQuestion.id);
                                                                        const wasLocationQuestion = removedQuestionDetails && removedQuestionDetails.questionType === 'location';

                                                                        setFilterQuestions(updatedFilters);

                                                                        // If a location question was removed, reset KML-related fields
                                                                        if (wasLocationQuestion) {
                                                                            setKMLFile(null);
                                                                            setKMLDistanceOption(null);
                                                                            setKMLDistanceOptionValue(1);
                                                                        }

                                                                        if (filterQuestion && filterQuestion.id === removedQuestion.id) {
                                                                            setFilterValue(null);
                                                                            setFilterQuestion(null);
                                                                            setSelectedFilterQuestionnaire(null);
                                                                        }
                                                                    }}
                                                                />
                                                            </Button.Group>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    )}

                    {hasLocationQuestionInFilters && (
                        <>
                            <Divider />
                            <Grid.Row>
                                <Grid.Column width={5}>
                                    <Label style={{ marginBottom: '8px' }}>KML File:</Label>
                                    <Dropdown
                                        placeholder="Select KML"
                                        fluid
                                        selection
                                        search
                                        options={kmlFileOptions}
                                        value={kmlFile}
                                        onChange={(e, { value }) => {
                                            setKMLFile(value);
                                        }}
                                    />
                                </Grid.Column>
                                {(kmlFile) && (
                                    <Grid.Column width={5} style={{ paddingBottom: "10px" }}>
                                        <Label style={{ marginBottom: '8px' }}>Distance Options:</Label>
                                        <Dropdown
                                            placeholder="Select distance option"
                                            fluid
                                            selection
                                            options={polygonRuleDistanceOptions}
                                            value={kmlDistanceOption || ''}
                                            onChange={(e, { value }) => {
                                                setKMLDistanceOption(value);
                                            }}
                                        />
                                    </Grid.Column>
                                )}
                                {(kmlFile && kmlDistanceOption === 'within_x_meters' || kmlDistanceOption === "within_x_meters_polygon_boundary") && (
                                    <Grid.Column width={4} style={{ paddingBottom: "10px" }}>
                                        <Label style={{ marginBottom: '8px' }}>Enter Distance (in meters):</Label>
                                        <Input
                                            fluid
                                            type="number"
                                            placeholder="Enter distance"
                                            value={kmlDistanceOptionValue || ''}
                                            onChange={(e) => setKMLDistanceOptionValue(e.target.value)}
                                            min="1"
                                        />
                                    </Grid.Column>
                                )}
                            </Grid.Row>
                        </>
                    )}
                    <Grid.Column floated="right" width={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        {canCreateQuestionnaireAnalysis() &&
                            <Form.Button
                                primary
                                fluid
                                loading={analyzeLoading}
                                style={{ marginTop: '24px' }}
                                onClick={analyse}
                                disabled={(() => {
                                    if (analyzeLoading || analysisQuestions.length === 0) return true;

                                    const mainQuestionType = analysisQuestions[0].questionType;
                                    const isLookupQuestion = ['yes_no', 'multi_select', 'mc_sel_one'].includes(mainQuestionType);
                                    const isTextQuestion = ['val_string', 'val_paragraph'].includes(mainQuestionType);

                                    if (isLookupQuestion && !lookupGraphType) return true;
                                    if (isTextQuestion && !textGraphType) return true;

                                    return false;
                                })()}
                            >
                                Analyse
                            </Form.Button>
                        }
                    </Grid.Column>
                </Grid>
                <Modal open={showFilterModal} onClose={() => setShowFilterModal(false)} size="small">
                    <Header>Select Filter Value</Header>
                    <Modal.Content>
                        {(() => {
                            if (!filterQuestion) return <div>Please select a filter question.</div>;

                            return (
                                <div>
                                    <div style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                                        <p><strong>Questionnaire:</strong> {selectedFilterQuestionnaire?.name || selectedFilterQuestionnaire?.title || 'Selected Questionnaire'}</p>
                                        <p><strong>Question:</strong> {filterQuestion.question}</p>
                                        <p><strong>Type:</strong> {filterQuestion.questionType}</p>
                                    </div>

                                    {(() => {
                                        const renderOptions = () => {
                                            if (filterQuestion.questionType === 'yes_no') {
                                                return (
                                                    <div>
                                                        <Radio
                                                            label="Yes"
                                                            name="filterValue"
                                                            value="yes"
                                                            checked={filterValue === 'yes'}
                                                            onChange={(e, { value }) => setFilterValue(value)}
                                                            style={{ display: 'block', marginBottom: '10px' }}
                                                        />
                                                        <Radio
                                                            label="No"
                                                            name="filterValue"
                                                            value="no"
                                                            checked={filterValue === 'no'}
                                                            onChange={(e, { value }) => setFilterValue(value)}
                                                        />
                                                    </div>
                                                );
                                            }

                                            if (filterQuestion.questionType === 'mc_sel_one' && props.questionLookup?.length > 0 && props.questionLookup[0]?.values) {
                                                const options = JSON.parse(props.questionLookup[0].values);
                                                return options.map((option, index) => (
                                                    <Radio
                                                        key={index}
                                                        label={option.value}
                                                        name="filterValue"
                                                        value={option.value}
                                                        checked={filterValue === option.value}
                                                        onChange={(e, { value }) => setFilterValue(value)}
                                                        style={{ display: 'block', marginBottom: '10px' }}
                                                    />
                                                ));
                                            }

                                            if (filterQuestion.questionType === 'multi_select' && props.questionLookup?.length > 0 && props.questionLookup[0]?.values) {
                                                const options = JSON.parse(props.questionLookup[0].values);
                                                return options.map((option, index) => (
                                                    <Checkbox
                                                        key={index}
                                                        label={option.value}
                                                        checked={Array.isArray(filterValue) ? filterValue.includes(option.value) : false}
                                                        onChange={(e, { checked }) => {
                                                            const currentValues = Array.isArray(filterValue) ? filterValue : [];
                                                            if (checked) {
                                                                setFilterValue([...currentValues, option.value]);
                                                            } else {
                                                                setFilterValue(currentValues.filter(v => v !== option.value));
                                                            }
                                                        }}
                                                        style={{ display: 'block', marginBottom: '10px' }}
                                                    />
                                                ));
                                            }

                                            return <div>No options available</div>;
                                        };

                                        return renderOptions();
                                    })()}
                                </div>
                            );
                        })()}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => setShowFilterModal(false)}>Cancel</Button>
                        <Button primary onClick={() => {
                            setShowFilterModal(false);
                            if (filterQuestion && filterValue) {
                                // Add the question and selected value to filterQuestions list
                                const filterObj = {
                                    id: filterQuestion.id,
                                    value: filterValue,
                                    questionnaireId: selectedFilterQuestionnaire.id,
                                    questionnaireName: selectedFilterQuestionnaire.name,
                                    question: filterQuestion.question,
                                    questionType: filterQuestion.questionType
                                };

                                // Check if this question is already in the list and update it
                                const existingIndex = filterQuestions.findIndex(q => q.id === filterQuestion.id);
                                if (existingIndex >= 0) {
                                    const updatedList = [...filterQuestions];
                                    updatedList[existingIndex] = filterObj;
                                    setFilterQuestions(updatedList);
                                } else {
                                    setFilterQuestions([...filterQuestions, filterObj]);
                                }

                                console.log("Selected filter value:", filterValue);
                                console.log("Updated filterQuestions list:", [...filterQuestions, filterObj]);

                                // Reset the filter selection state
                                setFilterQuestion(null);
                                setFilterValue(null);
                                setSelectedFilterQuestionnaire(null);
                            }
                        }}>Add Filter</Button>
                    </Modal.Actions>
                </Modal>

                {/* Analysis Questionnaire Selection Modal */}
                <Modal open={showAnalysisQuestionnaireModal} onClose={() => setShowAnalysisQuestionnaireModal(false)} size="small">
                    <Header>Select Questionnaire for Analysis</Header>
                    <Modal.Content>
                        <div style={{ marginBottom: '15px' }}>
                            <p>Select a questionnaire to choose analysis questions from:</p>
                        </div>
                        <Dropdown
                            placeholder="Select Questionnaire"
                            fluid
                            search
                            selection
                            options={questionnaireOptions}
                            value={selectedAnalysisQuestionnaire}
                            onChange={(e, { value }) => setSelectedAnalysisQuestionnaire(value)}
                        />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => setShowAnalysisQuestionnaireModal(false)}>Cancel</Button>
                        <Button
                            primary
                            disabled={!selectedAnalysisQuestionnaire}
                            onClick={() => {
                                if (selectedAnalysisQuestionnaire) {
                                    // Set the selected questionnaire for backward compatibility
                                    setSelectedQnaire(selectedAnalysisQuestionnaire);
                                    // Fetch questions for the selected questionnaire
                                    props.fetchQuestionnaireQuestions(selectedAnalysisQuestionnaire.id, null, selectedAnalysisQuestionnaire.tenantId);
                                    setShowAnalysisQuestionnaireModal(false);
                                    // Wait a moment for the questions to load, then show the questions modal
                                    setTimeout(() => setShowQuestionsModal(true), 500);
                                }
                            }}
                        >
                            Next
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* Questions Selection Modal */}
                <Modal open={showQuestionsModal} onClose={() => setShowQuestionsModal(false)} size="large">
                    <Header>Select Questions for Analysis</Header>
                    <Modal.Content>
                        <div style={{ marginBottom: '15px' }}>
                            <p><strong>Questionnaire:</strong> {selectedAnalysisQuestionnaire?.name || selectedAnalysisQuestionnaire?.title || selectedQnaire?.name || selectedQnaire?.title || 'Selected Questionnaire'}</p>
                            <p><strong>Instructions:</strong></p>
                            <ul>
                                <li>The first question you select will be tagged as the <strong>Main Question</strong></li>
                                <li><strong>Choice questions</strong> (yes_no, mc_sel_one, multi_select) can be selected together</li>
                                <li><strong>Text questions</strong> (val_string, val_paragraph) can <strong>only be selected individually</strong> - no other questions can be added</li>
                                <li><strong>Location questions</strong> can be selected with choice questions but not with text questions</li>
                                <li>Click "Select" to add a question for analysis - only the question ID and type are needed</li>
                                <li>Filter questions will still require value selection</li>
                            </ul>
                        </div>
                        {props.graphQuestions && props.graphQuestions.length > 0 ? (
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ borderBottom: '2px solid #ddd', backgroundColor: '#f8f9fa' }}>
                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Question</th>
                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Type</th>
                                        <th style={{ padding: '12px', textAlign: 'center', fontWeight: 'bold', width: '100px' }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.graphQuestions.map((question, index) => {
                                        const isAlreadySelected = analysisQuestions.some(aq => aq.id === question.id);

                                        // Define question type groups
                                        const choiceQuestions = ['yes_no', 'mc_sel_one', 'multi_select'];
                                        const textQuestions = ['val_string', 'val_paragraph'];
                                        const locationQuestions = ['location'];

                                        let canSelect = true;

                                        if (analysisQuestions.length > 0) {
                                            // Get the main question type from the stored analysisQuestions array
                                            const mainQuestionType = analysisQuestions[0].questionType;

                                            // If main question is text type, don't allow any additional questions
                                            if (['val_string', 'val_paragraph'].includes(mainQuestionType)) {
                                                canSelect = false;
                                            }
                                            // If current question is text type and there are already questions, don't allow it
                                            else if (['val_string', 'val_paragraph'].includes(question.questionType)) {
                                                canSelect = false;
                                            }
                                            // Location questions can be selected with everything except text questions
                                            else if (question.questionType === 'location' || mainQuestionType === 'location') {
                                                canSelect = true;
                                            }
                                            // Choice questions (yes_no, mc_sel_one, multi_select) can be selected together
                                            else if (choiceQuestions.includes(question.questionType) && choiceQuestions.includes(mainQuestionType)) {
                                                canSelect = true;
                                            }
                                            // Otherwise, questions must be of the same type
                                            else {
                                                canSelect = question.questionType === mainQuestionType;
                                            }
                                        }

                                        return (
                                            <tr key={question.id} style={{
                                                borderBottom: '1px solid #eee',
                                                backgroundColor: isAlreadySelected ? '#f0f8ff' : (!canSelect ? '#f8f9fa' : 'transparent'),
                                                opacity: !canSelect && !isAlreadySelected ? 0.6 : 1
                                            }}>
                                                <td style={{ padding: '12px' }}>
                                                    {question.question}
                                                    {!canSelect && !isAlreadySelected && (
                                                        <div style={{
                                                            fontSize: '11px',
                                                            color: '#6c757d',
                                                            fontStyle: 'italic',
                                                            marginTop: '4px'
                                                        }}>
                                                            {(() => {
                                                                const mainQuestionType = analysisQuestions[0]?.questionType;
                                                                if (['val_string', 'val_paragraph'].includes(mainQuestionType)) {
                                                                    return 'Text questions can only be analyzed individually';
                                                                }
                                                                if (['val_string', 'val_paragraph'].includes(question.questionType)) {
                                                                    return 'Cannot add text questions with other questions';
                                                                }
                                                                return 'Incompatible with selected question type';
                                                            })()}
                                                        </div>
                                                    )}
                                                </td>
                                                <td style={{ padding: '12px' }}>
                                                    <div style={{
                                                        backgroundColor: '#6c757d',
                                                        color: 'white',
                                                        padding: '2px 6px',
                                                        borderRadius: '10px',
                                                        fontSize: '12px',
                                                        display: 'inline-block'
                                                    }}>
                                                        {question.questionType}
                                                    </div>
                                                </td>
                                                <td style={{ padding: '12px', textAlign: 'center' }}>
                                                    <Button
                                                        size="mini"
                                                        primary
                                                        disabled={isAlreadySelected || !canSelect}
                                                        onClick={() => {
                                                            // For analysis questions, automatically add questionId and questionType without requiring value selection
                                                            const analysisQuestionObj = {
                                                                id: question.id,
                                                                value: null, // No value needed for analysis questions
                                                                questionType: question.questionType,
                                                                question: question.question,
                                                                questionnaireId: selectedAnalysisQuestionnaire.id || selectedQnaire.id,
                                                                questionnaireName: selectedAnalysisQuestionnaire.name || selectedQnaire.name,
                                                                tenantId: selectedAnalysisQuestionnaire.tenantId || selectedQnaire.tenantId,
                                                                cloudTenants: getCloudTenantsForQuestionnaire(selectedAnalysisQuestionnaire.id || selectedQnaire.id),
                                                            };

                                                            // Check if this question is already in the list and update it
                                                            const existingIndex = analysisQuestions.findIndex(q => q.id === question.id);
                                                            if (existingIndex >= 0) {
                                                                const updatedList = [...analysisQuestions];
                                                                updatedList[existingIndex] = analysisQuestionObj;
                                                                setAnalysisQuestions(updatedList);
                                                            } else {
                                                                setAnalysisQuestions([...analysisQuestions, analysisQuestionObj]);
                                                            }

                                                            // Close the questions modal after selection
                                                            // setShowQuestionsModal(false);
                                                        }}
                                                    >
                                                        {isAlreadySelected ? 'Selected' : 'Select'}
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        ) : (
                            <div style={{ textAlign: 'center', padding: '20px' }}>
                                <p>No questions available. Please select a questionnaire first.</p>
                            </div>
                        )}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => {
                            setShowQuestionsModal(false);
                            setShowAnalysisQuestionnaireModal(true);
                        }}>Back</Button>
                        <Button onClick={() => setShowQuestionsModal(false)}>Close</Button>
                    </Modal.Actions>
                </Modal>

                {/* Question Value Selection Modal */}
                <Modal open={showQuestionValueModal} onClose={() => setShowQuestionValueModal(false)} size="small">
                    <Header>Select Value for Question</Header>
                    <Modal.Content>
                        {(() => {
                            if (!selectedQuestion) return <div>Please select a question.</div>;

                            const renderValueOptions = () => {
                                // For analysis questions, only val_paragraph and val_string require value input
                                if (['val_string', 'val_paragraph'].includes(selectedQuestion.questionType)) {
                                    return (
                                        <>
                                            <Label style={{ marginBottom: '8px' }}>
                                                Enter Comma sepereate values to be ignored during analysis (optional):
                                            </Label>
                                            <Input
                                                fluid
                                                placeholder={"Example: ignore this, skip that"}
                                                value={selectedQuestionValue || ''}
                                                onChange={(e) => setSelectedQuestionValue(e.target.value)}
                                            />
                                        </>
                                    );
                                }

                                // For filter questions, handle all the original question types
                                if (selectedQuestion.questionType === 'yes_no') {
                                    return (
                                        <div>
                                            <Radio
                                                label="Yes"
                                                name="questionValue"
                                                value="yes"
                                                checked={selectedQuestionValue === 'yes'}
                                                onChange={(e, { value }) => setSelectedQuestionValue(value)}
                                                style={{ display: 'block', marginBottom: '10px' }}
                                            />
                                            <Radio
                                                label="No"
                                                name="questionValue"
                                                value="no"
                                                checked={selectedQuestionValue === 'no'}
                                                onChange={(e, { value }) => setSelectedQuestionValue(value)}
                                            />
                                        </div>
                                    );
                                }

                                if (selectedQuestion.questionType === 'mc_sel_one' && props.questionLookup?.length > 0 && props.questionLookup[0]?.values) {
                                    const options = JSON.parse(props.questionLookup[0].values);
                                    return options.map((option, index) => (
                                        <Radio
                                            key={index}
                                            label={option.value}
                                            name="questionValue"
                                            value={option.value}
                                            checked={selectedQuestionValue === option.value}
                                            onChange={(e, { value }) => setSelectedQuestionValue(value)}
                                            style={{ display: 'block', marginBottom: '10px' }}
                                        />
                                    ));
                                }

                                if (selectedQuestion.questionType === 'multi_select' && props.questionLookup?.length > 0 && props.questionLookup[0]?.values) {
                                    const options = JSON.parse(props.questionLookup[0].values);
                                    return options.map((option, index) => (
                                        <Checkbox
                                            key={index}
                                            label={option.value}
                                            checked={Array.isArray(selectedQuestionValue) ? selectedQuestionValue.includes(option.value) : false}
                                            onChange={(e, { checked }) => {
                                                const currentValues = Array.isArray(selectedQuestionValue) ? selectedQuestionValue : [];
                                                if (checked) {
                                                    setSelectedQuestionValue([...currentValues, option.value]);
                                                } else {
                                                    setSelectedQuestionValue(currentValues.filter(v => v !== option.value));
                                                }
                                            }}
                                            style={{ display: 'block', marginBottom: '10px' }}
                                        />
                                    ));
                                }

                                return <div>No value selection needed for this question type</div>;
                            };

                            return (
                                <div>
                                    <p><strong>{selectedQuestion.question}</strong></p>
                                    <p><em>Question Type: {selectedQuestion.questionType}</em></p>
                                    {renderValueOptions()}
                                </div>
                            );
                        })()}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => setShowQuestionValueModal(false)}>Cancel</Button>
                        <Button primary onClick={() => {
                            if (selectedQuestion) {
                                // For analysis questions, only val_paragraph and val_string require values
                                const requiresValue = ['val_paragraph', 'val_string'].includes(selectedQuestion.questionType);

                                if (!requiresValue || (selectedQuestionValue !== null && selectedQuestionValue !== '')) {
                                    const analysisQuestionObj = {
                                        id: selectedQuestion.id,
                                        value: requiresValue ? selectedQuestionValue : null,
                                        questionType: selectedQuestion.questionType,
                                        question: selectedQuestion.question,
                                        questionnaire: selectedAnalysisQuestionnaire || selectedQnaire,
                                        cloudTenants: getCloudTenantsForQuestionnaire((selectedAnalysisQuestionnaire || selectedQnaire).id),
                                    };

                                    // Check if this question is already in the list and update it
                                    const existingIndex = analysisQuestions.findIndex(q => q.id === selectedQuestion.id);
                                    if (existingIndex >= 0) {
                                        const updatedList = [...analysisQuestions];
                                        updatedList[existingIndex] = analysisQuestionObj;
                                        setAnalysisQuestions(updatedList);
                                    } else {
                                        setAnalysisQuestions([...analysisQuestions, analysisQuestionObj]);
                                    }

                                    setShowQuestionValueModal(false);
                                    setShowQuestionsModal(false);
                                    setSelectedQuestion(null);
                                    setSelectedQuestionValue(null);
                                } else {
                                    toast.error('Please enter a value for this question.');
                                }
                            }
                        }}>
                            Add Question
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* Filter Questionnaire Selection Modal */}
                <Modal open={showFilterQuestionnaireModal} onClose={() => setShowFilterQuestionnaireModal(false)} size="small">
                    <Header>Select Questionnaire for Filter</Header>
                    <Modal.Content>
                        <div style={{ marginBottom: '15px' }}>
                            <p>Select a questionnaire to choose filter questions from:</p>
                        </div>
                        <Dropdown
                            placeholder="Select Questionnaire"
                            fluid
                            search
                            selection
                            options={questionnaireOptions}
                            value={selectedFilterQuestionnaire}
                            onChange={(e, { value }) => setSelectedFilterQuestionnaire(value)}
                        />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => setShowFilterQuestionnaireModal(false)}>Cancel</Button>
                        <Button
                            primary
                            disabled={!selectedFilterQuestionnaire}
                            onClick={() => {
                                if (selectedFilterQuestionnaire) {
                                    // Fetch questions for the selected questionnaire
                                    props.fetchQuestionnaireQuestions(selectedFilterQuestionnaire.id, null, selectedFilterQuestionnaire.tenantId);
                                    setShowFilterQuestionnaireModal(false);
                                    // Wait a moment for the questions to load, then show the questions modal
                                    setTimeout(() => setShowFilterQuestionsModal(true), 500);
                                }
                            }}
                        >
                            Next
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* Filter Questions Selection Modal */}
                <Modal open={showFilterQuestionsModal} onClose={() => setShowFilterQuestionsModal(false)} size="large">
                    <Header>Select Filter Question</Header>
                    <Modal.Content>
                        <div style={{ marginBottom: '15px' }}>
                            <p><strong>Questionnaire:</strong> {selectedFilterQuestionnaire?.name || selectedFilterQuestionnaire?.title || 'Selected Questionnaire'}</p>
                            <p>Select a question to use as a filter:</p>
                        </div>
                        {props.graphQuestions && props.graphQuestions.length > 0 ? (
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ borderBottom: '2px solid #ddd', backgroundColor: '#f8f9fa' }}>
                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Question</th>
                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Type</th>
                                        <th style={{ padding: '12px', textAlign: 'center', fontWeight: 'bold', width: '100px' }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.graphQuestions
                                        .filter(q => ['yes_no', 'mc_sel_one', 'multi_select', 'location'].includes(q.questionType))
                                        .map((question, index) => {
                                            // Check if this is a location question
                                            const isLocationQuestion = question.questionType === 'location';

                                            // Check if there's already a location question selected
                                            const hasLocationQuestionSelected = filterQuestions.some(fq => {
                                                const existingQuestion = props.graphQuestions.find(q => q.id === fq.id);
                                                return existingQuestion && existingQuestion.questionType === 'location';
                                            });

                                            // Disable location questions if one is already selected
                                            const isDisabled = isLocationQuestion && hasLocationQuestionSelected;

                                            return (
                                                <tr key={question.id} style={{
                                                    borderBottom: '1px solid #eee',
                                                    backgroundColor: isDisabled ? '#f8f9fa' : 'transparent',
                                                    opacity: isDisabled ? 0.6 : 1
                                                }}>
                                                    <td style={{ padding: '12px' }}>
                                                        {question.question}
                                                        {isLocationQuestion && hasLocationQuestionSelected && (
                                                            <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '4px' }}>
                                                                Only one location question allowed
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td style={{ padding: '12px' }}>
                                                        <div style={{
                                                            backgroundColor: isLocationQuestion ? '#e74c3c' : '#6c757d',
                                                            color: 'white',
                                                            padding: '2px 6px',
                                                            borderRadius: '10px',
                                                            fontSize: '12px',
                                                            display: 'inline-block'
                                                        }}>
                                                            {question.questionType}
                                                        </div>
                                                    </td>
                                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                                        <Button
                                                            size="mini"
                                                            primary
                                                            disabled={isDisabled}
                                                            onClick={() => {
                                                                // Check if this is a location question
                                                                if (question.questionType === 'location') {
                                                                    // For location questions, add directly without filter value selection
                                                                    const filterObj = {
                                                                        id: question.id,
                                                                        question: question.question,
                                                                        questionType: question.questionType,
                                                                        questionnaireId: selectedFilterQuestionnaire.id,
                                                                        questionnaireName: selectedFilterQuestionnaire.name,
                                                                        tenantID: selectedFilterQuestionnaire.tenantId,
                                                                        value: null // No filter value needed for location questions
                                                                    };

                                                                    // Add to filter questions list
                                                                    setFilterQuestions([...filterQuestions, filterObj]);

                                                                    // Close the modal
                                                                    setShowFilterQuestionsModal(false);

                                                                } else {
                                                                    // For non-location questions, proceed with normal filter value selection
                                                                    setFilterQuestion(question);
                                                                    setFilterValue(null);
                                                                    props.fetchQuestionLookup(question);
                                                                    setShowFilterQuestionsModal(false);
                                                                    setShowFilterModal(true);
                                                                }
                                                            }}
                                                        >
                                                            {'Select'}
                                                        </Button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        ) : (
                            <div style={{ textAlign: 'center', padding: '20px' }}>
                                <p>No filter questions available for this questionnaire.</p>
                            </div>
                        )}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => {
                            setShowFilterQuestionsModal(false);
                            setShowFilterQuestionnaireModal(true);
                        }}>Back</Button>
                        <Button onClick={() => setShowFilterQuestionsModal(false)}>Close</Button>
                    </Modal.Actions>
                </Modal>
            </Segment>
            <Segment style={{ minHeight: 120, position: 'relative', zIndex: 0 }}>
                {/* {state.loading ? (
                    <Dimmer active inverted>
                        <Loader inverted>Loading saved queries...</Loader>
                    </Dimmer>
                ) : null} */}
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <h3>Saved Queries</h3>
                            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                                <thead>
                                    <tr style={{ borderBottom: '2px solid #ddd', backgroundColor: '#f8f9fa' }}>
                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>User Group</th>
                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>KML File</th>
                                        <th style={{ padding: '12px', textAlign: 'center', fontWeight: 'bold' }}>Analysis Questions</th>
                                        <th style={{ padding: '12px', textAlign: 'center', fontWeight: 'bold' }}>Filter Questions</th>
                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Date Range</th>
                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Graph Types</th>
                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Created</th>
                                        <th style={{ padding: '12px', textAlign: 'center', fontWeight: 'bold', width: '150px' }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.customeAnalysisQueries && props.customeAnalysisQueries.length > 0 ? (
                                        props.customeAnalysisQueries.map((query, index) => {
                                            // Format dates
                                            const formatDate = (dateString) => {
                                                if (!dateString) return 'N/A';
                                                try {
                                                    return new Date(dateString).toLocaleDateString();
                                                } catch (e) {
                                                    return dateString;
                                                }
                                            };

                                            const formatCreatedAt = (createdAt) => {
                                                if (!createdAt) return 'N/A';
                                                try {
                                                    // Handle format like "20250804T134254"
                                                    if (createdAt.includes('T') && !createdAt.includes(':')) {
                                                        const year = createdAt.substring(0, 4);
                                                        const month = createdAt.substring(4, 6);
                                                        const day = createdAt.substring(6, 8);
                                                        const hour = createdAt.substring(9, 11);
                                                        const minute = createdAt.substring(11, 13);
                                                        const second = createdAt.substring(13, 15);
                                                        const isoString = `${year}-${month}-${day}T${hour}:${minute}:${second}Z`;
                                                        return new Date(isoString).toLocaleDateString();
                                                    }
                                                    return new Date(createdAt).toLocaleDateString();
                                                } catch (e) {
                                                    return createdAt;
                                                }
                                            };

                                            // Count questions
                                            const analysisQuestionsCount = query.analysisQuestions ? query.analysisQuestions.length : 0;
                                            const filterQuestionsCount = query.filterQuestions ? query.filterQuestions.length : 0;

                                            return (
                                                <tr key={query.id || index} style={{ borderBottom: '1px solid #eee' }}>
                                                    <td style={{ padding: '12px' }}>
                                                        {query.userGroup ? (
                                                            <div style={{
                                                                backgroundColor: '#28a745',
                                                                color: 'white',
                                                                padding: '4px 8px',
                                                                borderRadius: '12px',
                                                                fontSize: '12px',
                                                                display: 'inline-block',
                                                                maxWidth: '150px',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis'
                                                            }}>
                                                                {query.userGroup.name || query.userGroup.id || 'Unnamed Group'}
                                                            </div>
                                                        ) : (
                                                            <div style={{
                                                                backgroundColor: '#6c757d',
                                                                color: 'white',
                                                                padding: '4px 8px',
                                                                borderRadius: '12px',
                                                                fontSize: '12px',
                                                                display: 'inline-block'
                                                            }}>
                                                                No Group
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td style={{ padding: '12px' }}>
                                                        {query.kmlName ? (
                                                            <div style={{
                                                                backgroundColor: '#17a2b8',
                                                                color: 'white',
                                                                padding: '4px 8px',
                                                                borderRadius: '12px',
                                                                fontSize: '12px',
                                                                display: 'inline-block',
                                                                maxWidth: '150px',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis'
                                                            }}>
                                                                {query.kmlName}
                                                            </div>
                                                        ) : (
                                                            <div style={{
                                                                backgroundColor: '#6c757d',
                                                                color: 'white',
                                                                padding: '4px 8px',
                                                                borderRadius: '12px',
                                                                fontSize: '12px',
                                                                display: 'inline-block'
                                                            }}>
                                                                No KML
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                                        <div style={{
                                                            backgroundColor: analysisQuestionsCount > 0 ? '#e74c3c' : '#6c757d',
                                                            color: 'white',
                                                            padding: '6px 12px',
                                                            borderRadius: '20px',
                                                            fontSize: '14px',
                                                            fontWeight: 'bold',
                                                            display: 'inline-block',
                                                            minWidth: '30px'
                                                        }}>
                                                            {analysisQuestionsCount}
                                                        </div>
                                                    </td>
                                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                                        <div style={{
                                                            backgroundColor: filterQuestionsCount > 0 ? '#3498db' : '#6c757d',
                                                            color: 'white',
                                                            padding: '6px 12px',
                                                            borderRadius: '20px',
                                                            fontSize: '14px',
                                                            fontWeight: 'bold',
                                                            display: 'inline-block',
                                                            minWidth: '30px'
                                                        }}>
                                                            {filterQuestionsCount}
                                                        </div>
                                                    </td>
                                                    <td style={{ padding: '12px' }}>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <div><strong>Start:</strong> {formatDate(query.startDate)}</div>
                                                            <div><strong>End:</strong> {formatDate(query.endDate)}</div>
                                                        </div>
                                                    </td>
                                                    <td style={{ padding: '12px' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                            {query.lookupGraphType && (
                                                                <div style={{
                                                                    backgroundColor: '#007bff',
                                                                    color: 'white',
                                                                    padding: '2px 6px',
                                                                    borderRadius: '10px',
                                                                    fontSize: '11px',
                                                                    display: 'inline-block'
                                                                }}>
                                                                    Lookup: {query.lookupGraphType}
                                                                </div>
                                                            )}
                                                            {query.textGraphType && (
                                                                <div style={{
                                                                    backgroundColor: '#6f42c1',
                                                                    color: 'white',
                                                                    padding: '2px 6px',
                                                                    borderRadius: '10px',
                                                                    fontSize: '11px',
                                                                    display: 'inline-block'
                                                                }}>
                                                                    Text: {query.textGraphType}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td style={{ padding: '12px' }}>
                                                        <div style={{ fontSize: '12px' }}>
                                                            {formatCreatedAt(query.createdAt)}
                                                        </div>
                                                    </td>
                                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                                        <Button.Group size="mini">
                                                            <Button
                                                                className="view-analysis-btn"
                                                                icon={state.navigating ? "spinner" : "eye"}
                                                                color="blue"
                                                                title="View Analysis Data"
                                                                loading={state.navigating}
                                                                disabled={state.navigating}
                                                                style={{
                                                                    position: 'relative',
                                                                    overflow: 'hidden'
                                                                }}
                                                                onClick={async () => {
                                                                    try {
                                                                        // Set navigating state
                                                                        setState(prev => ({ ...prev, navigating: true }));

                                                                        // Set the selected query in Redux state
                                                                        props.setSelectedCustomQueryAction(query);

                                                                        // Show success message
                                                                        toast.success('Loading analysis data...');

                                                                        // Small delay for better UX
                                                                        await new Promise(resolve => setTimeout(resolve, 500));

                                                                        // Navigate elegantly using React Router
                                                                        history.push('/General Actions/Custom Analysis Data');
                                                                    } catch (error) {
                                                                        toast.error('Failed to navigate to analysis data');
                                                                        setState(prev => ({ ...prev, navigating: false }));
                                                                    }
                                                                }}
                                                            />
                                                            <Button
                                                                icon="edit"
                                                                color="green"
                                                                title="Load Query"
                                                                onClick={() => {
                                                                    // Load the query data into the form
                                                                    if (query.userGroup) setUserGroup(query.userGroup);
                                                                    if (query.kmlFileId && query.kmlName) {
                                                                        const kmlFileObj = {
                                                                            id: query.kmlFileId,
                                                                            name: query.kmlName,
                                                                            kmlMarkers: query.kmlMarkers || [],
                                                                            kmlPolygons: query.kmlPolygons || [],
                                                                            kmlPolylines: query.kmlPolylines || []
                                                                        };
                                                                        setKMLFile(kmlFileObj);
                                                                    }
                                                                    if (query.kmlDistanceOption) setKMLDistanceOption(query.kmlDistanceOption);
                                                                    if (query.kmlDistanceOptionValue) setKMLDistanceOptionValue(query.kmlDistanceOptionValue);
                                                                    if (query.lookupGraphType) setLookupGraphType(query.lookupGraphType);
                                                                    if (query.textGraphType) setTextGraphType(query.textGraphType);
                                                                    if (query.startDate) setStartDate(new Date(query.startDate));
                                                                    if (query.endDate) setEndDate(new Date(query.endDate));
                                                                    if (query.analysisQuestions) setAnalysisQuestions(query.analysisQuestions);
                                                                    if (query.filterQuestions) setFilterQuestions(query.filterQuestions);

                                                                    toast.success('Query loaded successfully');
                                                                }}
                                                            />
                                                            <Button
                                                                icon="trash"
                                                                color="red"
                                                                title="Delete Query"
                                                                onClick={() => {
                                                                    // Handle delete action
                                                                    if (window.confirm('Are you sure you want to delete this query?')) {
                                                                        props.deleteCustomQueryAction(query);
                                                                    }
                                                                }}
                                                            />
                                                        </Button.Group>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="8" style={{ padding: '20px', textAlign: 'center', color: '#6c757d' }}>
                                                No saved queries found. Create your first analysis to see it here.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
        </Form >
    );
};
const mapStateToProps = (state) => {
    const graphQuestionTypes = [
        'location',
        'yes_no',
        'multi_select',
        'mc_sel_one',
        'val_string',
        'val_paragraph',
        'lickert',
    ];

    const filterQuestionTypes = [
        'yes_no',
        'multi_select',
        'mc_sel_one',
        'location',
    ];

    return {
        userPermissions: _.isEmpty(state.authUserRoles.permissions)
            ? {}
            : state.authUserRoles.permissions,
        isPermissionsFetched: state.isPermissionsFetched === true,
        graphQuestions: Array.isArray(state.deepAnalysisQuestions)
            ? state.deepAnalysisQuestions.filter(q => graphQuestionTypes.includes(q.questionType))
            : [],
        filterQuestion: Array.isArray(state.deepAnalysisQuestions)
            ? state.deepAnalysisQuestions.filter(q => filterQuestionTypes.includes(q.questionType))
            : [],
        questionLookup: state.lookups || {},
        userGroups: state.userGroups || {},
        kmlFiles: state.kmlFiles || {},
        tenantClouds: state.tenantClouds || [],
        customeAnalysisQueries: state.customeAnalysisQueries || [],
    };
};

export default connect(
    mapStateToProps,
    // map dispatch to props
    (dispatch) => ({
        analyseCustomQueryAction: (payload) => dispatch(DEEPANALYSIS_ACTIONS.analyseCustomQueryAction(payload)),
        fetchQuestionnaireQuestions: (questionaireId, sectionId, tenantId) => dispatch(DEEPANALYSIS_ACTIONS.fetchQuestionsAction(questionaireId, sectionId, tenantId)),
        fetchCustomQuueriesAction: (tenant) => dispatch(DEEPANALYSIS_ACTIONS.fetchCustomQueriesAction(tenant)),
        fetchUserGroupsAction: (tenant) => dispatch(USER_GROUPS.fetchUserGroupsAction(tenant)),
        fetchKmlFilesAction: (tenant) => dispatch(KML_ACTIONS.fetchKmlFilesAction(tenant)),
        fetchTenantCloudsAction: () => dispatch(TENANT_CLOUD_ACTIONS.fetchTenantCloudsAction()),
        fetchQuestionLookup: (question) => dispatch(LOOKUPS_ACTIONS.fetchLookupsAction(question)),
        clearDeepAnalysisQueryAction: () => dispatch(DEEPANALYSIS_ACTIONS.clearDeepAnalysisQueryAction()),
        deleteCustomQueryAction: (query) => dispatch(DEEPANALYSIS_ACTIONS.deleteCustomQueryAction(query)),
        setSelectedCustomQueryAction: (query) => dispatch(DEEPANALYSIS_ACTIONS.setSelectedCustomQueryAction(query)),
    })
)(CustomAnalysisQueryPage);
